import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import { Paper, Typography, Box, styled, Chip, Skeleton } from "@mui/material";

export const S = {
    Benchmark: styled(Paper)(({ theme }) => ({
        padding: theme.spacing(5, 6),
        borderRadius: theme.shape.borderRadius * 4,
        minWidth: 250,
        width: 450,
        border: `1px solid ${theme.palette.divider}`,
        scrollSnapAlign: "start",
        elevation: 0,
    })),

    BenchmarkLoading: styled(Box)(({ theme }) => ({
        width: 250,
        height: 150,
        position: "relative",
        borderRadius: theme.shape.borderRadius * 4,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        overflow: "hidden",
    })),

    BenchmarkLoadingIcon: styled(CloudOutlinedIcon)(({ theme }) => ({
        color: theme.palette.text.secondary,
        position: "absolute",
        top: 20,
        right: 21,
        zIndex: 1,
    })),

    BenchmarkLoadingSkeleton: styled(Skeleton)(({ theme }) => ({
        width: "100%",
        height: "100%",
    })),

    Header: styled(Box)(() => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    })),

    HeaderTitle: styled(Typography)(() => ({
        fontSize: "10px",
        fontWeight: "bold",
        textTransform: "uppercase",
        color: "text.secondary",
    })),

    ValueLabel: styled(Typography)(({ theme }) => ({
        fontSize: 12,
        fontWeight: 400,
        color: theme.palette.text.secondary,
    })),

    Value: styled(Typography)(() => ({
        fontSize: 26,
        fontWeight: 700,
        display: "inline-block",
    })),

    Unit: styled(Typography)(() => ({
        fontSize: 14,
        fontWeight: 700,
        marginLeft: 4,
        display: "inline-block",
    })),

    Chip: styled(Chip)(() => ({
        fontSize: 12,
    })),
};
